import toast from '@/resources/services/toast'
import { INVENTORY_ERRORS_CODES } from '@/resources/enums/errors/inventoryErrors'
import { REQUEST_ERRORS_CODES } from '@/resources/enums/errors/requestErrors'

import { doLogout } from '@/proxy/auth/logout'

export const requestMiddleware = async request => {
  return {
    ...request,
    credentials: 'include',
    headers: {
      ...request.headers,
      withCredentials: true,
    },
  }
}

const shouldRedirectToMaintenancePage = () => {
  const pagesWithDefaultMaintenanceError = [
    'management',
    'my-account',
    'orders-map',
    'performance',
  ]

  return pagesWithDefaultMaintenanceError.some(page =>
    window.location.href.includes(page)
  )
}

const pagesWithDefaultError = ['poc-orders']

const shouldToastError = statusError => {
  return (
    (statusError === 500 || statusError === 503) &&
    pagesWithDefaultError.some(page => window.location.href.includes(page))
  )
}

const handleCircuitBreakerOpen = () => {
  if (
    shouldRedirectToMaintenancePage() &&
    !window.location.href.includes('maintenance')
  ) {
    window.location.replace('/maintenance')
  }
}

const handleMiddlewareErrors = (error, errorCode) => {
  if (error.type === 'AuthenticationException') return doLogout()

  if (errorCode === REQUEST_ERRORS_CODES.CIRCUIT_IS_OPEN) {
    handleCircuitBreakerOpen()
    return
  }
}

export const responseMiddleware = response => {
  const parsedResponse = JSON.parse(JSON.stringify(response))

  const error =
    parsedResponse?.response?.data?.error || parsedResponse?.data?.error

  const codeError = error?.code

  const ignoreErrorCode = INVENTORY_ERRORS_CODES[codeError]

  if (!codeError || ignoreErrorCode) return

  handleMiddlewareErrors(error, codeError)

  const statusError = parsedResponse?.response?.status

  if (shouldToastError(statusError)) {
    return
  } else {
    toast.showDefaultError(statusError)
  }
}
